<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false" :fix-width="false" :auto-width="true" max-width="90vw">
        <template slot="main">
            <ItemDescription :item="item" :forecast="forecast" />
            <ItemImage :item="item" />
            <br />
            <div><ItemQuantities :itemId="item.id" :forecast="forecast" :full="false" /></div>
        </template>
    </ModalTheme>
</template>
<script>
import ItemQuantities from "@/components/forecasts/elements/catalogue/ItemQuantities";
import ModalTheme from "@/components/ui/ModalTheme";
import ItemDescription from "@/components/forecasts/elements/ItemDescription";
import ItemImage from "@/components/forecasts/elements/ItemImage";

export default {
    components: {
        ItemImage,
        ItemDescription,
        ItemQuantities,
        ModalTheme
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        forecast: {
            type: Object,
            required: true
        }
    },
    methods: {
        closeModal() {
            this.$emit("closed");
        }
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// ItemQuantitiesModal.vue?9cf24002